import { Icon } from '@ss/mtd-react';
import React, { FC } from 'react';
import './index.scss';
import { useRootStore } from '@src/model';
import dayjs from 'dayjs';

import { ISocialBaseInfo } from '@src/types/resumeDetail/socialType';
import { ICampusBaseInfo } from '@/src/types/resumeDetail/campusType';

interface IProps {
  data: ISocialBaseInfo | ICampusBaseInfo;
  type: string;
  setMode: Function;
}

const BaseInfoView: FC<IProps> = (props) => {
  const { type, data, setMode } = props;

  const { campusResumeFormRefStore, socialResumeFormRefStore } = useRootStore();
  let storeRef;
  if (type === 'campus') {
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    storeRef = socialResumeFormRefStore;
  }

  const handleEdit = () => {
    storeRef.setCurrentScrollRef('base_info_edit');
    setMode('edit');
  };

  return data ? (
    <div className="base_info_view model_view">
      <div className="model_title">
        <div>基础信息</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      <div className="model_main">
        <img className="avatar" src={data.photoUrl || require('@imgs/avatar.png')} alt="" />
        <div className="info">
          <div className="name">{data.name}</div>
          {type === 'social' && (
            <div className="detail">
              {data.genderName && <span>{data.genderName}</span>}
              {data.genderName && <span className="gap">|</span>}
              {data?.birthday && <span>{dayjs(data?.birthday).format('YYYY/MM')}</span>}
              {data?.birthday && <span className="gap">|</span>}
              {/* @ts-ignore */}
              {data?.degreeName && <span>{data?.degreeName}</span>}
              {/* @ts-ignore */}
              {data?.degreeName && <span className="gap">|</span>}
              {/* @ts-ignore */}
              <span>{data.workYear}年工作经验</span> <span className="gap">|</span>
              <span>现居城市：{data.cityName || ''}</span> <span className="gap">|</span>
              {/* @ts-ignore */}
              <span>期望城市：{data.expectedCity || ''}</span>
            </div>
          )}
          {type === 'campus' && (
            <div className="detail">
              {data.genderName && <span>{data.genderName}</span>}
              {data.genderName && <span className="gap">|</span>}
              <span>现居城市：{data.cityName || ''}</span>
              {/* @ts-ignore */}
              {data.identificationNo && data.identificationType !== 'NOTA' && <span className="gap">|</span>}
              {/* @ts-ignore */}
              {data.identificationNo && data.identificationType !== 'NOTA' && <span>{data.identificationNo}</span>}
            </div>
          )}
          <div className="information">
            <img src={require('@imgs/photo_icon.svg')} alt="" /> <span>{data.phone}</span>
            <img src={require('@imgs/email.svg')} alt="" /> <span>{data.email}</span>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default BaseInfoView;
